module.exports = __webpack_public_path__ + "img/SketchPnga0bf32d5590bee74ee0ef96b91428310d2f35b61db09b8266c2298a6f08ff59c.e76503b1.png";